document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-phone-only]').forEach((input) => {
    input.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, 14);
    });
  });
  document.querySelectorAll('[data-char-count-source]').forEach((textarea) => {
    const counter = textarea.closest('label')?.querySelector('[data-char-count]');
    const update = () => {
      if (textarea.value.length > 150) textarea.value = textarea.value.slice(0, 150);
      if (counter) counter.textContent = textarea.value.length;
    };
    textarea.addEventListener('input', update);
    update();
  });
});
